import React from 'react';

import { MacWindowBody, MacWindowDot, MacWindowDotWrapper, MacWindowHeaderWrapper } from '../ui/mac-window';
import { FlexContainer } from '../ui/flex';

const MacWindow = ({ title = '', children }) => (
    <FlexContainer $column $gap='0px'>
        <MacWindowHeaderWrapper>
            <MacWindowDotWrapper>
                <MacWindowDot></MacWindowDot>
                <MacWindowDot></MacWindowDot>
                <MacWindowDot></MacWindowDot>
            </MacWindowDotWrapper>
            <div>{title}</div>
            <div></div>
        </MacWindowHeaderWrapper>
        <MacWindowBody>{children}</MacWindowBody>
    </FlexContainer>
);

export default MacWindow;
